<template>
    <div class="table-box vehicle-table">

        <data-table
            title="Vehicles"
            delete-button-text="selected vehicles"
            :headers="headers"
            :get-items-handler="getVehicles"
            :get-delete-handler="deleteVehicle"
            :get-prepared-data-to-save="prepareDataToSave"
            :deletable="hasAllRoles(['VehicleDelete'])"
        >
            <template v-slot:items="item">
                <td>
                    <template v-if="hasAllRoles(['VehicleUpdate'])">
                        <router-link :to="{ name: 'editVehicle', params: { fleetUuid: uuid, vehicleUuid: item.props.item.id } }">
                            {{ item.props.item.registrationNumber }}
                        </router-link>
                    </template>
                    <template v-else>
                        {{ item.props.item.registrationNumber }}
                    </template>
                </td>
                <td>
<!--                    <router-link v-if="item.props.item.driver" :to="{ name: 'editUsers', params: { username: item.props.item.driver.name } }">-->
<!--                        {{ item.props.item.driver.name }}-->
<!--                    </router-link>-->
                    {{ item.props.item.driver ? item.props.item.driver.name : ''}}
                </td>
                <td>{{ item.props.item.model }}</td>
                <td>{{ item.props.item.manufacturer }}</td>
                <td>{{ item.props.item.yearOfManufacture }}</td>
                <td>{{ mapFuelType(item.props.item.fuelType) }}</td>
                <td>{{ item.props.item.mileage }}</td>
                <td>{{ item.props.item.engineSize }}</td>
                <td>{{ mapVehicleType(item.props.item.type) }}</td>
                <td v-if="hasAllRoles(['VehicleUpdate'])" class="text-center">
                    <router-link :to="{ name: 'editVehicle', params: { fleetUuid: uuid, vehicleUuid: item.props.item.id } }">
                        <sp-button design-type="table-button" icon="edit"></sp-button>
                    </router-link>
                </td>
            </template>

            <template v-slot:createButton v-if="hasAllRoles(['VehicleAdd'])">
                <router-link :to="{ name: 'createVehicle', params: { uuid: uuid } }" class="no-underline">
                    <sp-button sp-class="no-padding-right" icon="car" text="Add vehicle"></sp-button>
                </router-link>
            </template>
        </data-table>
    </div>
</template>

<script>
import SpButton from '../../components/forms/Button'
import VehicleApi from '@/api/VehicleApi';
import { mapGetters } from 'vuex'
import toast from '../../plugins/izitoast'
import DataTable from '../_components/DataTable'
import { searchEnumById } from "@/helpers/Utils"

const vehicleApi = new VehicleApi()

export default {
    name: 'VehiclesList',
    components: {
        SpButton,
        DataTable
    },
    props: {
        uuid: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            totalResults: 0,
            vehicles: []
        }
    },
    computed: {
        ...mapGetters({
            getFuelTypes: 'dictionaryModule/getFuelTypes',
            getVehicleTypes: 'dictionaryModule/getVehicleTypes',
        }),
        headers () {
            return [
                {
                    text: 'Registration number',
                    sortable: true,
                    value: 'registrationNumber'
                },
                {
                    text: 'Driver',
                    sortable: true,
                    value: 'Driver.Name'
                },
                {
                    text: 'Model',
                    sortable: true,
                    value: 'model'
                },
                {
                    text: 'Manufacturer',
                    sortable: true,
                    value: 'manufacturer'
                },
                {
                    text: 'Year of manufacture',
                    sortable: true,
                    value: 'yearOfManufacture'
                },
                {
                    text: 'Fuel type',
                    sortable: false,
                    value: 'fuelType'
                },
                {
                    text: 'Mileage',
                    sortable: true,
                    value: 'mileage'
                },
                {
                    text: 'Engine size',
                    sortable: true,
                    value: 'engineSize'
                },
                {
                    text: 'Vehicle type',
                    sortable: false,
                    value: 'vehicleType'
                },
                {
                    text: 'Edit',
                    sortable: false,
                    value: 'isEditable',
                    width: '70px',
                    class: !this.hasAllRoles(['VehicleUpdate']) ? 'd-none' : ''
                },
                {
                    text: 'Delete',
                    sortable: false,
                    value: 'isDeletable',
                    width: '70px',
                    class: !this.hasAllRoles(['VehicleDelete']) ? 'd-none' : ''
                }
            ]
        }
    },
    methods: {
        async getVehicles (page, rowsPerPage, search, sortBy) {
            const response = await vehicleApi.getVehicles({
                skip: (page - 1) * rowsPerPage,
                take: rowsPerPage,
                fleetId: this.uuid,
                registrationNumber: search,
                orderBy: sortBy
            })
            this.totalResults = response.payload.totalResults
            this.vehicles = response.payload.items
            return {
                total: response.payload.totalResults,
                items: response.payload.items
            }
        },
        async deleteVehicle (vehicle) {
            const response = await vehicleApi.deleteVehicle(vehicle.id)

            if (!response.isSuccess) {
                return
            }
            toast.success(`Vehicle ${vehicle.registrationNumber} successfully deleted.`)
        },
        mapFuelType (fuelId) {
            let fuel = searchEnumById(this.getFuelTypes, fuelId)

            return fuel || '-'
        },
        mapVehicleType (vehicleType) {
            let vehicle = searchEnumById(this.getVehicleTypes, vehicleType)

            return vehicle || '-'
        },
        async prepareDataToSave (search) {
            const dataToSave = []
            let items = []

            const response = await vehicleApi.getVehicles({
                skip: null,
                take: null,
                fleetId: this.uuid,
                registrationNumber: search
            })
            items = items.concat(response.payload.items)

            items.forEach(item => {
                dataToSave.push({
                    registrationNumber: item.registrationNumber,
                    driver: item.driver ? item.driver.name : '',
                    model: item.model,
                    manufacturer: item.manufacturer,
                    yearOfManufacture: item.yearOfManufacture,
                    fuelType: this.mapFuelType(item.fuelType),
                    mileage: item.mileage,
                    engineSize: item.engineSize,
                    vehicleType: this.mapVehicleType(item.type)
                })
            })
            return dataToSave
        }
    }
}
</script>

<style scoped lang="scss">
.vehicle-table {
    margin-bottom: 30px;

    .v-btn {
        &.margin-right {
            margin-right: 10px !important;
        }
    }
}

</style>
